import React from 'react';
import { tinaField } from 'tinacms/dist/react';
import type { ContentQueryQuery } from '@/tina/__generated__/types';
import { PageTitle } from '@/app/(base)/components/blocks/page-title';
import { Content } from '@/app/(base)/components/blocks/content';
import { PlatformMetrics } from '@/app/(base)/components/blocks/platform-metrics';
import { FundLogos } from '@/app/(base)/components/blocks/fund-logos';

// [key] is the name of the module in TinaCMS
const components = {
  PageBlocksPageTitle: PageTitle,
  PageBlocksContent: Content,
  PageBlocksPlatformMetrics: PlatformMetrics,
  PageBlocksFunds: FundLogos,
};

export function Blocks({
  items,
}: {
  items: ContentQueryQuery['page']['blocks'];
}): React.JSX.Element | null {
  if (!items) {
    return null;
  }

  return (
    <>
      {items.map((block, i) => {
        if (!block) {
          return null;
        }

        const Component = components[block.__typename];

        if (typeof Component !== 'undefined') {
          return (
            <div
              data-tina-field={tinaField(block)}
              key={i.toString() + block.__typename}>
              {/*eslint-disable-next-line @typescript-eslint/no-explicit-any -- It is hard to explain the type here*/}
              <Component {...(block as any)} />
            </div>
          );
        }

        return (
          <Placeholder
            componentName={block.__typename}
            key={i.toString() + block.__typename}
          />
        );
      })}
    </>
  );
}

function Placeholder({
  componentName,
}: {
  componentName: string | number;
}): React.JSX.Element {
  return (
    <section className='border border-danger bg-danger-muted py-4 text-center'>
      <p className='mx-auto text-center text-danger'>
        The component <strong>{componentName}</strong> has not been created yet.
      </p>
    </section>
  );
}
